@if (visible) {
	<div class="spinner-section">
    <span [ngClass]="(spinning) ? 'saving-icon-spin' : 'saving-icon-static'">
      <svg-icon name="{{iconName}}" [svgStyle]="svgStyle"></svg-icon>
    </span>
		@if (iconName === 'loader-pumpkin') {
			<span style="color: #ee7f00;" [style.font-size]="waitingTextSize" class="saving-caption" [ngClass]="{'hide': hideCaptionOnSmallScreen}">{{ waitingText }}</span>
		}
		@if (iconName !== 'loader-pumpkin') {
			<span style="color: #007d40" class="saving-caption" [ngClass]="{'hide': hideCaptionOnSmallScreen}" [ngStyle]="{'font-size': waitingTextSize}">{{ waitingText }}</span>
		}
	</div>
}
